import { createApiRef } from '@backstage/core-plugin-api';

const techRadarApiRef = createApiRef(
  {
    id: "plugin.techradar.service"
  }
);
var MovedState = /* @__PURE__ */ ((MovedState2) => {
  MovedState2[MovedState2["Down"] = -1] = "Down";
  MovedState2[MovedState2["NoChange"] = 0] = "NoChange";
  MovedState2[MovedState2["Up"] = 1] = "Up";
  return MovedState2;
})(MovedState || {});

export { MovedState, techRadarApiRef };
//# sourceMappingURL=api.esm.js.map
